export enum GraphType {
  WATER_LEVEL = 'WATER_LEVEL',
  TEMPERATURE = 'TEMPERATURE',
  EVENTS = 'EVENTS',
}
